export const SET_USER = 'octadesk/user/set'

export const SET_USER_EMAIL = 'octadesk/user/set/email'

export const SET_USER_ID = 'octadesk/user/set/id'

export const SET_ONLINE_AGENTS = 'SET_ONLINE_AGENTS'
